import { Row, Col, Button, Container, Modal } from "react-bootstrap";
import { checkForAPISuccess, responseToastHandler, showInfoToast, showErrorToast } from "../../../Common/commonFunctions";
import _ from "lodash";
import { Icon } from "@iconify/react";
import { useQuery } from "react-query";
import { fetchPreviousAndCurrentInformation, revertComponentById } from "../../../api";
import { useEffect, useState } from "react";
import { ClipLoader } from "react-spinners";
import { useDispatch } from "react-redux";
import { UPDATE_COMPONENT_INFORMATION } from '../../../store/actions';
import { RESPONSE_CATEGORY_CREATED_COMPONENT_REVERT_CODE } from "../../../Common/constants";

const RevertPopup = props => {

    const [utils, setUtils] = useState({
        previous: {}, current: {}, rowBeingModified: {},
        isUpdateOrRevertOngoing: false, isOverallRevert: false,
        isOverallRevertClicked: false, currentUnchanged: {}
    });

    const dispatch = useDispatch();
    const useQueryConfiguration = {
        enabled: false, retry: false, retryOnMount: false,
        refetchOnMount: "always", refetchOnWindowFocus: false
    };

    const fetchOldAndCurrentDetails = useQuery({
        queryKey: 'fetch-old-and-current-details-' + props.target,
        queryFn: async () => {
            const response = await fetchPreviousAndCurrentInformation(props.id);
            const responseData = response?.data;
            if(checkForAPISuccess(responseData?.statusCode)) {
                if(!_.isEmpty(responseData.data)) {
                    setUtils({ 
                        ...utils, current: !_.isEmpty(responseData.data.current) ? responseData.data.current : {},
                        previous: !_.isEmpty(responseData.data.previous) ? responseData.data.previous : {},
                        currentUnchanged: !_.isEmpty(responseData.data.current) ? responseData.data.current : {}
                    });
                }
            }
            else if(responseData?.statusCode === RESPONSE_CATEGORY_CREATED_COMPONENT_REVERT_CODE) {
                showInfoToast("This is a category creaated component which does not have any install time information", 5000);
            }
            else {
                showErrorToast("Failed to get component information");
            }
        },
        ...useQueryConfiguration
    });

    const updateInformation = async () => {
        const response = await revertComponentById(props.id, utils.current, utils.isOverallRevert);
        return response?.data;
    }

    const updateInformationQuery = useQuery("update-information", updateInformation, {...useQueryConfiguration});

    useEffect(() => {
        if(updateInformationQuery.isFetched) {
            if(updateInformationQuery.isSuccess && checkForAPISuccess(updateInformationQuery?.data?.statusCode)) {
                dispatch({ type: UPDATE_COMPONENT_INFORMATION, payload: _.pickBy(utils.current, (val) => !_.isEmpty(val)) });
                const onSuccess = { message: `Component Information ${utils.isOverallRevert ? "reverted" : "updated"} successfully`, callBack: () => {} }
                responseToastHandler(updateInformationQuery?.data?.statusCode, null, onSuccess, null);
                setUtils({ ...utils, isUpdateOrRevertOngoing: false, isOverallRevert: false });
            }
            else {
                showErrorToast("Failed to update component information");
                setUtils({
                    ...utils, isUpdateOrRevertOngoing: false,
                    isOverallRevert: false, isOverallRevertClicked: false,
                    current: _.cloneDeep(utils.currentUnchanged)
                });
            }
            updateInformationQuery.remove();
        }
    }, [updateInformationQuery.isFetched]);

    useEffect(() => {
        if(utils.isUpdateOrRevertOngoing) {
            updateInformationQuery.refetch();
        }
    }, [utils.isUpdateOrRevertOngoing]);

    useEffect(() => {
        fetchOldAndCurrentDetails.refetch();
    }, []);

    const patchUpdateInformation = (key, value) => 
        setUtils({
            ...utils, rowBeingModified: key,
            isUpdateOrRevertOngoing: true,
            current: _.set(utils.current, key, value)
        });

    const revertAll = () => {
        let updatedInfo = _.clone(utils.previous);
        if(!_.isEmpty(utils.current)) {
            Object.keys(utils.current).forEach(key => {
                if(_.isEmpty(updatedInfo[key])) {
                    updatedInfo[key] = "";
                }
            });
        }
        setUtils({
            ...utils, current: updatedInfo, isOverallRevert: true, 
            isUpdateOrRevertOngoing: true, isOverallRevertClicked:true
        });
    }

    const returnColumns = (value, className) => 
        <Col className = {className} md={4} lg={4} xs={4} xl={4} sm={4}>
            {value}
        </Col>

    return (
        <Modal show={true} backdrop="static" size="lg" onHide={() => props.close()}>

            <Modal.Header closeButton>
                <h4 className="font-weight-bold"> Component data revert </h4>
            </Modal.Header>

            <Modal.Body>
            {
                (fetchOldAndCurrentDetails.isFetching || utils.isOverallRevert) ?
                    <center className="my-5">
                        <ClipLoader color="#075978" />
                    </center>
                        :
                    <Container className="mb-5">
                    {
                        !_.isEmpty(utils.previous) || !_.isEmpty(utils.current) ?
                        <>
                            <Row style={{"fontSize": "17px"}} className="text-center my-3">
                                { returnColumns("Parameter", "font-weight-bold") }
                                { returnColumns("Install time info", "font-weight-bold") }
                                { returnColumns("User updated info", "font-weight-bold") }
                            </Row>
                        {
                            Object.keys({ ...utils.previous, ...utils.current }).map((key, index) => 
                                <Row key={index} className={`p-0 text-center ${index % 2 === 0 ? "revert-even" : "revert-odd"}`} >
                                    { returnColumns(key, "font-weight-bold text-left") }
                                    <Col className="" md={4} lg={4} xs={4} xl={4} sm={4}>
                                    {
                                        !_.isEmpty(utils.previous[key]) ?
                                            _.isEqual(utils.previous[key], utils.current[key]) ?
                                                <>
                                                    {
                                                        (updateInformationQuery.isFetching && _.isEqual(key, utils.rowBeingModified)) ?
                                                        <ClipLoader color="#075978" speedMultiplier={1.1} size={25} />
                                                            :
                                                        <>
                                                            { utils.previous[key] }
                                                            <Icon width={20} style={{"marginLeft": "7px", "marginBottom": "4px"}} color="green" icon={"feather-check"} />
                                                        </>
                                                    }
                                                </>
                                                    :
                                                <div>
                                                    <span 
                                                        onClick={() => { patchUpdateInformation(key, utils.previous[key]) }}
                                                        className={`link ${updateInformationQuery.isFetching ? "disable-click" : ""}`}>
                                                            { utils.previous[key] }
                                                    </span>
                                                </div>
                                            :
                                        <>
                                            <Icon icon={"feather-minus"} />
                                        </>
                                    }
                                    </Col>
                                    <Col md={4} lg={4} xs={4} xl={4} sm={4}>
                                    {
                                        !_.isEmpty(utils.current[key]) ?
                                            _.isEqual(utils.previous[key], utils.current[key]) ?
                                                <Icon icon={"feather-minus"} />
                                                    :
                                                <>
                                                    { utils.current[key] }
                                                    <Icon width={20} style={{"marginLeft": "7px", "marginBottom": "4px"}} color="green" icon={"feather-check"} />
                                                </>
                                            :
                                        <>
                                            REMOVED FROM DASHBOARD
                                        </>
                                    }
                                    </Col>
                                </Row>
                            )
                        }
                        </>
                            :
                        <div className="my-5">
                            <center>
                                <b> NO INFORMATION AVAILABLE FOR REVERT </b>
                            </center>
                        </div>
                    }
                    </Container>
            }
            </Modal.Body>

            <Modal.Footer>
                <Button
                    disabled={
                        fetchOldAndCurrentDetails.isFetching || _.isEmpty(utils.previous) ||
                        _.isEqual(utils.current, utils.previous) ||  utils.isOverallRevertClicked
                    }
                    onClick={() => revertAll()}
                >
                    Revert all
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default RevertPopup;